<template>
  <div class="swipe--cta" @click="increment()">
    <svgicon
      class="icon"
      name="swipe-pointer"
      color="var(--ui-white)"
      height="1.625rem"
      width="1.625rem"
    />
    {{ label }}
  </div>
</template>

<script>
export default {
  name: "SwipeCta",
  props: {
    label: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.swipe--cta {
  @include dida-XS;
  color: $gray_04;
  width: fit-content;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: auto;
  .icon {
    margin-right: toRem(5);
    transition: transform 0.5s ease;
  }
}

.tablet {
  .swipe--cta {
    @include dida-S;
    .icon {
      width: 1.875rem;
      height: 1.875rem;
    }
  }
}
</style>
